<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('guest.hotel.title') }}</div>
                <div class="mainBody">
                    <img class='preview-img' widths="3092" heights="3401" width='100%' @click="bigImg"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map2_en.jpg?v=1220' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map2_en.jpg?v=1220'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map2_en.jpg?v=1220' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map2_en.jpg?v=1220'">
                    <p class="center" style="margin-bottom: .3rem;padding-top:.15rem">{{ $t('guest.hotel.tips3') }}</p>

                    <img class='preview-img' widths="3216" heights="1612" width='100%' @click="bigImg"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1_en.jpg?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1_en.jpg?v=0223'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1_en.jpg?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/map1_en.jpg?v=0223'">
                    <p class="center" style="margin-bottom: .3rem;padding-top:.15rem">{{ $t('guest.hotel.tips2') }}</p>

                    <!-- <img class='preview-img' widths="1200" heights="710" width='100%' @click="bigImg"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map3_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map3.png?v=0223'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map3_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map3.png?v=0223'">
                    <p class="center" style="margin-bottom: .3rem;padding-top:.15rem">{{ $t('guest.hotel.title1') }}</p>

                    <img class='preview-img' widths="1200" heights="940" width='100%' @click="bigImg"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map4_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map4.png?v=0223'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map4_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map4.png?v=0223'">
                    <p class="center" style="margin-bottom: .3rem;padding-top:.15rem">{{ $t('guest.hotel.title2') }}</p>

                    <img class='preview-img' widths="1200" heights="800" width='100%' @click="bigImg"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map5_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map5.png?v=0223'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map5_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/map5.png?v=0223'">
                    <p class="center" style="margin-bottom: .3rem;padding-top:.15rem">{{ $t('guest.hotel.title3') }}</p> -->
                </div>
            </div>
        </div>
        <div class="back" @click="path('guest')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>
<script>
import Photo from '../../components/PhotoSwipe';
import menus from "../../components/menu.vue"
export default {
    components: {
        menus,
        Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest/hotel']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        bigImg(el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close(e) {
            this.bigImg_show = e;
        },
    }
}
</script>
<style scoped>
.container {
    padding-bottom: .5rem;
}

img {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/guest/hotel.vue